import { redirectWithUri } from 'Auth/shared/utils/redirectWithRedirectUrl'
import { setAxiosDefaults } from 'axiosConfig'
import { UserManager, UserManagerSettings } from 'oidc-client-ts'
import { startTransition, StrictMode } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'
import { LOCAL_STORAGE_REDIRECT_URL_LOGOUT } from 'shared/constants/localStorageVariables'
import { setReferrer } from 'shared/utils/referrer'
import { initSentry } from '../sentry'

setAxiosDefaults()
setReferrer()
initSentry()

if (window.location.pathname.indexOf('/silentredirect') !== -1) {
  new UserManager({} as UserManagerSettings).signinSilentCallback().then()
} else if (localStorage.getItem(LOCAL_STORAGE_REDIRECT_URL_LOGOUT)) {
  redirectWithUri()
} else {
  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <HydratedRouter />
      </StrictMode>
    )
  })
}
